import React, {useEffect, useState} from 'react';
import { useParams } from 'react-router-dom';
import orderApi from '../../../services/apiServices/orderApi';
import './OrderPage.css';
import { useDispatch } from 'react-redux';
import { setLoading } from '../../../services/redux/loadingSlice';
import { toast } from 'react-toastify';
import { maskCEP, maskCPF } from '../../../components/masks/masks';
import { putDateOnPattern } from '../../../utils/functions';
import { saveAs } from 'file-saver';
import configService from '../../../services/configService';

const OrderPage = () => {
    const { code } = useParams();
    const dispatch = useDispatch();
    const [order, setOrder] = useState(undefined);
    const [items, setItems] = useState(undefined);
    const [historyOrder, setHistoryOrder] = useState([]);
    const [refresh, setRefresh] = useState(false);

    useEffect(() => {
        const fetchOrder =  async () => {
            dispatch(setLoading(true));
            try {
                const response = await orderApi.getOrderByCode(code, {include: 'Customer.User.Address.City,OrderHistory,Customer.CustomerType,OrderTransaction'});
                setOrder(response);
                setItems(JSON.parse(response.StItems));
                setHistoryOrder(response.OrderHistory);
            } catch (error) {
                toast.error('Erro ao buscar os dados do pedido.');
            } finally {
                dispatch(setLoading(false));
            }
        }

        fetchOrder();
    }, [code, refresh, dispatch]);

    const getIntegrationBody = async (id, nr) => {
        try{
            dispatch(setLoading(true));

            var response = await orderApi.getOrderIntegrationByCode(id, {include: 'Customer.User.Address.City,OrderHistory,Customer.CustomerType,OrderTransaction'});
            downloadItem(nr, response.ResponseContent)
        }
        catch{
            toast.error('Erro ao baixar');
        }
        finally{
            dispatch(setLoading(false));
        }
    }

    const updateWithBemPaggo = async (id) => {
        try{
            dispatch(setLoading(true));

            var response = await orderApi.updateOrderWithBemPaggo(id);
            if(response.OrderTransaction){
                toast.success('Atualizado com sucesso!');
            }
            else{
                toast.error('Erro ao atualizar.');
            }

            setRefresh(prev => !prev);
        }
        catch{
            toast.error('Erro ao baixar');
        }
        finally{
            dispatch(setLoading(false));
        }
    }

    const downloadItem = (nr, data) => {
        const blob = new Blob([data], { type: 'application/xml; charset=utf-8' });
        saveAs(blob, `${nr}.xml`);
    };

    const isExpired = (expirationDate) => {
        return new Date(expirationDate) < new Date();
    };

    if(order === undefined)
        return(<div className='customer-container'>Carregando</div>)
    else
    return (
    <div className="container-admin-page">
        <div className='space-double-bottom'>
            <div className='flex-space-between margin-bottom'>
                <h1>Pedido {configService.getOrderDescription(order.OrderStatusId)}</h1>
                <div className='flex-row gap-default space-between'>
                    <button className='main-button' onClick={() => getIntegrationBody(order.Id, order.NrOrder)}>Baixar XML de integração</button>
                    <button className='main-button' onClick={() => updateWithBemPaggo(order.Id)}>Atualizar com BemPaggo</button>
                </div>
            </div>
            <div>
                <div className="box space-double-bottom">
                    <div>
                        <h2>Informações do pedido</h2>
                    </div>
                    <div className="flex-row gap-triple-default">
                        <div className="info-group">
                            <p><strong>Id:</strong> {order.Id}</p>
                            <p><strong>Número do Pedido:</strong> {order.NrOrder}</p>
                            <p><strong>Número Referência (ERP):</strong> {order.RefOrder}</p>
                            <p><strong>Status:</strong> {configService.getOrderDescription(order.OrderStatusId)}</p>
                            <p><strong>Permite Pagamento:</strong> {isExpired(order.ExpirationDate) ? 'Não permite pagamento' : configService.getOrderAllowPayment(order.AllowPayment)}</p>
                            <p><strong>Guid do pedido:</strong> {order.GuidOrder}</p>
                        </div>
                        <div className="info-group">
                            <p><strong>Id da BemPaggo:</strong> {order.BemPaggoId}</p>
                            <p><strong>Valor do pedido:</strong> {order.VlrFormat}</p>
                            <p><strong>Tipo do pedido:</strong> {configService.getIsDigital(order.IsDigital)}</p>
                            <p><strong>Data criação:</strong> {putDateOnPattern(order.Created)}</p>
                            <p><strong>Data atualização:</strong> {putDateOnPattern(order.Updated)}</p>
                            <p><strong>Data expiração:</strong> {putDateOnPattern(order.ExpirationDate)}</p>
                        </div>
                    </div>
                </div>

                <div className="box space-double-bottom">
                    <div>
                        <h2>Itens do pedido</h2>
                    </div>
                    <div className="info-group">
                        {items.map((item, index) => (
                            <div key={index} className="order-item div-with-border">
                                {
                                    item.ISBN ? 
                                    <img
                                        src={`https://pwm-public-product-pro.s3.amazonaws.com/${item.ISBN}-large.webp`}
                                        alt="Produto"
                                        className="order-item-image"
                                    />  
                                    :
                                    <img
                                        src="https://pwm-public-static-pro.s3.amazonaws.com/static/img/no-cover.png"
                                        alt="Produto"
                                        className="order-item-image"
                                    />
                                }
                                <div className="order-item-details padding-default">
                                    <h2 className="order-item-title">{item.Description}</h2>
                                    <div className="flex-column gap-default">
                                        {
                                            item.ISBN ? 
                                            <div className="flex-row x-small-font space-between margin-bottom">
                                                <p>Cod. ERP: {item.CDERP}</p>
                                                <p>ISBN: {item.ISBN}</p>
                                            </div>
                                            :
                                            <div className="x-small-font margin-bottom">
                                                <p>Cod. ERP: {item.CDERP}</p>
                                            </div>
                                        }
                                        <p className="order-item-price">R$ {item.UnitPrice.toFixed(2).replace('.', ',')}</p>
                                    </div>
                                    <div className="order-item-quantity margin-top-default">
                                        <label className="quantity-label">Quantidade: {item.Quantity}</label>
                                    </div>
                                </div>
                        </div>
                        ))}
                    </div>
                </div>


                <div className="box">
                    <div className='margin-bottom'>
                        <h2>Informações do cliente</h2>
                    </div>
                    <div className="flex-row gap-triple-default">
                        <div className='info-group'>
                            <p><strong>Id:</strong> {order?.Customer?.Id ?? 'Não informado'}</p>
                            <p><strong>Nome:</strong> {order?.Customer?.User?.Name ?? 'Não informado'}</p>
                            <p><strong>Email:</strong> {order?.Customer?.User?.Email ?? 'Não informado'}</p>
                            <p><strong>CPF/CNPJ:</strong> {order?.Customer?.User?.Document1 ? maskCPF(order.Customer.User.Document1) : 'Não informado'}</p>
                            <p><strong>Guid:</strong> {order?.Customer?.User?.GuidCustomer ?? 'Não informado'}</p>
                            <p><strong>Tipo de Pessoa:</strong> {order?.Customer?.PersonType ? configService.getPersonType(order?.Customer?.PersonType) : 'Não informado'}</p>
                        </div>

                        <div className='info-group'>
                            <p><strong>Endereço:</strong> 
                                {order?.Customer?.User?.Address?.[0]?.StStreet && order?.Customer?.User?.Address?.[0]?.NrBuildIngsite
                                    ? `${order.Customer.User.Address[0].StStreet}, ${order.Customer.User.Address[0].NrBuildIngsite}`
                                    : 'Não informado'}
                            </p>
                            <p><strong>Bairro:</strong> {order?.Customer?.User?.Address?.[0]?.StNeighborhood ?? 'Não informado'}</p>
                            <p><strong>Complemento:</strong> {order?.Customer?.User?.Address?.[0]?.StComplement || 'Não informado'}</p>
                            <p><strong>Cidade:</strong> 
                                {order?.Customer?.User?.Address?.[0]?.City?.Name && order?.Customer?.User?.Address?.[0]?.City?.State
                                    ? `${order.Customer.User.Address[0].City.Name} - ${order.Customer.User.Address[0].City.State}`
                                    : 'Não informado'}
                            </p>
                            <p><strong>CEP:</strong> 
                                {order?.Customer?.User?.Address?.[0]?.StZipCode 
                                    ? maskCEP(order.Customer.User.Address[0].StZipCode) 
                                    : 'Não informado'}
                            </p>
                        </div>
                    </div>
                </div>
            </div>

        </div>

        {
            order.OrderStatusId === 1 && 
            <div className='space-double-bottom'>
                <h1>Transação</h1>

                <div className="box space-double-bottom info-group">
                    <p><strong>Forma de Pagamento:</strong> {order.OrderTransaction[0].CodePaymentMethod} - {order.OrderTransaction[0].CodePaymentOption}</p>
                    <p><strong>Código Recibo:</strong> {order.OrderTransaction[0].CodereCeiptSale}</p>
                    <p><strong>Nsu:</strong> {order.OrderTransaction[0].Nsu}</p>
                    <p><strong>Status:</strong> {order.OrderTransaction[0].StAutorization}</p>
                    <p><strong>Valor Pago:</strong> {order.OrderTransaction[0].VlPaid}</p>
                    <p><strong>Data do pagamento:</strong> {order.OrderTransaction[0].PaymentDate}</p>
                    <p><strong>Última atualização:</strong> {order.OrderTransaction[0].Updated}</p>
                </div>
            </div>
        }

        <div>
            <h1>Histórico do pedido</h1>

            <div className='container-admin-page-table div-with-border'>
                <table className="admin-table">
                    <thead>
                        <tr>
                            <th>Data</th>
                            <th>Título</th>
                            <th>Descrição</th>
                        </tr>
                    </thead>
                    <tbody>
                    {historyOrder.map((item) => (
                        <tr key={item.Id}>
                            <td><span>{putDateOnPattern(item.Created)}</span></td>
                            <td><span>{item.Title}</span></td>
                            <td><span>{item.Description}</span></td>
                        </tr>
                    ))}
                    </tbody>
                </table>
                <sub>Total de itens no histório: {historyOrder.length}</sub>
            </div>
        </div>
    </div>
  );
};

export default OrderPage;
